import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
// Adjust this import to wherever your RootState lives (same as your other slices).
import type { RootState } from "@/store";

export interface InvoiceSessionState {
  lightning: { invoice: string; invoiceId: string };
  // invoice = the ADDRESS (bcrt1q...); invoiceId = the order id.
  onchain: { invoice: string; invoiceId: string; btcAmount: number };
  // Absolute deadline (epoch milliseconds — a fixed point in time, NOT a
  // "seconds left" counter). Persisting this single number is what makes the
  // timer refresh-proof: remaining = expiresAt - Date.now(), so a refresh at
  // minute 7 resumes at exactly 8:00 left.
  expiresAt: number | null;
}

const initialState: InvoiceSessionState = {
  lightning: { invoice: "", invoiceId: "" },
  onchain: { invoice: "", invoiceId: "", btcAmount: 0 },
  expiresAt: null,
};

const invoiceSessionSlice = createSlice({
  name: "invoiceSession",
  initialState,
  reducers: {
    // Written ONCE per mint (in createInvoiceMutation.onSuccess). Nothing else
    // ever touches expiresAt — that is the invariant that stops timer resets.
    setInvoiceSession: (_state, action: PayloadAction<InvoiceSessionState>) =>
      action.payload,
    resetInvoiceSession: () => initialState,
  },
});

export const { setInvoiceSession, resetInvoiceSession } =
  invoiceSessionSlice.actions;

export const getInvoiceSession = (state: RootState) => state.invoiceSession;

export default invoiceSessionSlice.reducer;
